import { render } from "./NoticeManage.vue?vue&type=template&id=60592dda&scoped=true"
import script from "./NoticeManage.vue?vue&type=script&lang=js"
export * from "./NoticeManage.vue?vue&type=script&lang=js"

import "./NoticeManage.vue?vue&type=style&index=0&id=60592dda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60592dda"]])

export default __exports__